<template>
    <div class="data-wrapper-core">
        <h3>Uploads</h3>
        <v-divider></v-divider>
        <div v-for="(upload, id) in uploads" :key="id">
            <h4>Benutzter Speicher:</h4>
            <p>{{ upload.usedStorage }}</p>
            <h4>__v:</h4>
            <p>{{ upload.__v }}</p>
            <v-divider class="lead-uploads-divider"></v-divider>
            <v-expansion-panels class="subuser-panels">
                <v-expansion-panel rounded="lg" v-for="(blob, index) in upload.blobs" :key="index">
                    <v-expansion-panel-title class="email-templates-panel-title">
                        <h4>{{ blob.filename }}</h4>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text class="email-templates-panel-text">
                        <v-divider></v-divider>
                        <div v-for="(value, key) in blob" :key="key">
                            <h4>{{ key }}</h4>
                            <p>{{ value }}</p>
                        </div>
                    </v-expansion-panel-text>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {

    computed: {
        ...mapState('lead', ['uploads']),
    },

}
</script>

<style lang="scss" scoped>
.lead-uploads-divider {
    margin: 12px 0;
}

.subuser-panels {
    margin: 8px 0;
}
</style>